import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleHeaderComponent } from './module-header.component';
import { ButtonModule } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { ToolbarModule } from 'primeng/toolbar';
import { MenuModule } from 'primeng/menu';
import { UserActionsModule } from '../user-actions/user-actions.module';

@NgModule({
  declarations: [ModuleHeaderComponent],
  imports: [CommonModule, ButtonModule, PopoverModule, ToolbarModule, MenuModule, UserActionsModule],
  exports: [ModuleHeaderComponent],
})
export class ModuleHeaderModule {}
